module.exports = __webpack_public_path__ + "static/media/cto.7b365e88.jpg";